import { useTranslation } from '@eti/providers';
import { Badge } from '@etg/wings';
import { OrderState } from '@eti/schema-types';

const ORDER_STATE_INFO = {
  [OrderState.Canceled]: {
    variant: 'critical',
    textKey: 'OrderDetails.OrderState.Canceled',
  },
  [OrderState.Changed]: {
    variant: 'caution',
    textKey: 'OrderDetails.OrderState.Changed',
  },
} as const;

interface OrderStateInfoProps {
  orderState: typeof OrderState.Canceled | typeof OrderState.Changed;
}

const OrderStateInfo = ({ orderState }: OrderStateInfoProps) => {
  const { t } = useTranslation();
  const orderStateInfo = ORDER_STATE_INFO[orderState];

  return (
    <Badge data-testid={`order-state-${orderState}`} variant={orderStateInfo.variant}>
      {t(orderStateInfo.textKey)}
    </Badge>
  );
};

export default OrderStateInfo;
